import { useState } from "react";
import Button from "components/Elements/Button/Button.js";
import Image from "components/Elements/Image/Image.tsx";
import Cursor from "components/Reusable/VideoCursor/Cursor/Cursor.tsx";
import useMediaQueries from "hooks/useMediaQueries.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import VideoModal from "components/Reusable/VideoCursor/Modal/VideoModal.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";

const MainBanner = () => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { desktopCondition } = useMediaQueries();
  const { setModal } = useModal();
  const [isHover, setIsHover] = useState(false);

  // const scrollToCreatePageSection = () => {
  //   document
  //     .getElementById("create-embed-page-id")
  //     .scrollIntoView({ behavior: "smooth", block: "center" });
  // };

  const openVideoClick = () => {
    setModal({
      modal: VideoModal,
      props: {
        src: "https://www.youtube.com/embed/Oty4U4WAww0?autoplay=1",
      },
    });
  };

  return (
    <div
      className={`first-section${isHover ? " cursor-hidden" : ""}`}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="background-main-section">
        <Image name="embed-forms/bg-banner" ext="png" alt="" title="" />
      </div>
      <div className="content">
        <h3>{getTextByKey("jumbo-forms-main-section-h1")}</h3>
        <h1>{getTextByKey("jumbo-forms-first-section-title")}</h1>
        <p>{getHtmlByKey("jumbo-forms-first-section-text1")} </p>
        <div className="section-button">
          <LinkToNewTab page="user/jumbo-forms/form-management">
            <Button
              green
              className="embed-button"
              onMouseEnter={() => setIsHover(false)}
              onMouseLeave={() => setIsHover(true)}
            >
              {getTextByKey("jumbo-forms-get-started")}
            </Button>
          </LinkToNewTab>
          <Button
            blank
            onMouseEnter={() => setIsHover(false)}
            onMouseLeave={() => setIsHover(true)}
            onClick={openVideoClick}
          >
            <div className="icon-container">
              <Icon name="play" />
            </div>
            {getTextByKey("watch-video-text")}
          </Button>
        </div>
      </div>
      <div className="image">
        <Image
          name={
            !desktopCondition
              ? "embed-forms/jumbo-form-main-mob"
              : "embed-forms/jumbo-form-main"
          }
          ext="png"
        />
      </div>
      <Cursor
        isHover={isHover}
        setIsHover={setIsHover}
        color="#17cb49"
        handleClick={openVideoClick}
      />
    </div>
  );
};

export default MainBanner;
